"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M2.5 14.016a2.503 2.503 0 0 1-2.5-2.5v-7c0-1.378 1.122-2.5 2.5-2.5h19c1.378 0 2.5 1.122 2.5 2.5v7c0 1.378-1.122 2.5-2.5 2.5h-19ZM1 4.516v4.5h22v-4.5c0-.827-.673-1.5-1.5-1.5h-19c-.827 0-1.5.673-1.5 1.5Zm0 5.5v1.5c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5v-1.5H1Zm6.674 11.853a.502.502 0 0 0 .707 0c1.107-1.108.562-2.484.124-3.59-.447-1.124-.69-1.843-.124-2.411a.5.5 0 0 0-.707-.706c-1.06 1.06-.528 2.404-.1 3.484.461 1.162.712 1.904.1 2.516a.5.5 0 0 0 0 .707Zm4.339.146a.5.5 0 0 1-.354-.853c.612-.612.36-1.354-.1-2.515-.429-1.08-.961-2.424.1-3.485a.5.5 0 0 1 .707.707c-.567.567-.323 1.285.123 2.409.438 1.106.983 2.483-.123 3.591a.499.499 0 0 1-.353.146Zm3.63-.146a.502.502 0 0 0 .707 0c1.106-1.108.561-2.484.124-3.59l-.001-.001c-.446-1.124-.69-1.842-.123-2.41a.5.5 0 0 0-.707-.706c-1.06 1.06-.528 2.404-.1 3.484.461 1.162.712 1.904.1 2.516a.5.5 0 0 0 0 .707Zm5.865-9.853h-19a.5.5 0 0 1 0-1h19a.5.5 0 0 1 0 1ZM3 7.516a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0v3Zm3.5.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5Zm2.5-.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0v3Zm3.5.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5Zm2.5-.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0v3Zm3.5.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5Zm3.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z",
    clipRule: "evenodd"
  })]
});